module.exports = __webpack_public_path__ + "assets/images/-1.c26495e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kits/-1.png
// module id = 822
// module chunks = 1